/**
 * Environment config, resolved at container start rather than build time, so
 * one image ships to every environment.
 *
 * `docker-entrypoint.sh` writes `env-config.js` from the container's
 * `REACT_APP_*` vars; it sets `window.__ENV__` before the bundle loads. The
 * `process.env` fallback keeps the dev server, storybook and jest working.
 */
/** Empty counts as unset — an unpopulated secret renders as `''`, not absent. */
const read = (key) => {
    const value = window.__ENV__?.[key] ?? process.env[key];
    return value === '' ? undefined : value;
};
export const appConfig = {
    api: read('REACT_APP_API') ?? '',
    onboardApi: read('REACT_APP_ONBOARD_API') ?? '',
    stripePk: read('REACT_APP_STRIPE_PK') ?? '',
    recaptchaKey: read('REACT_APP_RECAPTCHA_KEY') ?? '',
    googleMapsKey: read('REACT_APP_GOOGLE_MAPS_KEY') ?? '',
    datadogRumAppId: read('REACT_APP_DATADOG_RUM_APP_ID'),
    datadogRumClientToken: read('REACT_APP_DATADOG_RUM_CLIENT_TOKEN'),
    posthogKey: read('REACT_APP_POSTHOG_KEY'),
    posthogHost: read('REACT_APP_POSTHOG_HOST'),
    /** Session replay stays off unless explicitly `'true'`. */
    posthogSessionReplay: read('REACT_APP_POSTHOG_SESSION_REPLAY') === 'true',
    /** Share of sessions recorded, 0 to 1; unset follows the project setting. */
    posthogSessionReplaySampleRate: read('REACT_APP_POSTHOG_SESSION_REPLAY_SAMPLE_RATE'),
    /** Deployment environment name; gates analytics and tags Datadog RUM. */
    env: read('REACT_APP_NODE_ENV') ?? 'development',
    /** Build-time identity of the artifact — not environment-specific. */
    buildId: process.env['REACT_APP_BUILD_ID'] ?? 'dev'
};
export const isProduction = appConfig.env === 'production';
/**
 * Called from the app entry. Without the API bases every request silently
 * resolves against the frontend's own origin, so fail loudly instead.
 */
export const assertConfig = () => {
    const missing = ['api', 'onboardApi'].filter((key) => !appConfig[key]);
    if (missing.length > 0) {
        throw new Error(`Missing environment config: ${missing.join(', ')}. Set REACT_APP_API and REACT_APP_ONBOARD_API.`);
    }
};
